import React from "react"
import { Box, makeStyles } from "@material-ui/core"
import { FC } from "react"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { DiscountType, IMenuProduct, OfferDisplayLabelType } from "shared/Types/appTypes"
import { TagRounded } from "./Tag"

type OfferTagProps = StyleProps & {
    product: IMenuProduct
}

type StyleProps = Readonly<{
    top: string
    right: string
}>

const useStyles = makeStyles(() => ({
    container: ({ top, right }: StyleProps) => ({
        position: "absolute",
        top,
        right,
    }),
}))

export const OfferTag: FC<OfferTagProps> = ({ product, top, right }) => {
    const classes = useStyles({ top, right })

    const { offerDetails } = product
    if (!offerDetails) return null

    const { discount } = offerDetails

    if (!discount || discount.displayLabelType === OfferDisplayLabelType.OLD_NEW_PRICE) {
        return null
    }

    const getTagText = () => {
        switch (discount.displayLabelType) {
            case OfferDisplayLabelType.SAVE_X:
                if (discount.type === DiscountType.DISCOUNT_PERCENTAGE) {
                    return (
                        <LocalizedStrict id="offer-tag-save-x-percentage" vars={{ amount: discount.percentage.amount }}>
                            <>
                                `${discount.percentage.amount}% off / Spar ${discount.percentage.amount}%`
                            </>
                        </LocalizedStrict>
                    )
                } else if (discount.type === DiscountType.DISCOUNT_PRICE) {
                    return (
                        <LocalizedStrict
                            id="offer-tag-save-x-price"
                            vars={{ amount: discount.originalPrice?.amount || 0 }}
                        >
                            <>`Save ${discount.originalPrice?.amount} kr`</>
                        </LocalizedStrict>
                    )
                }
                return null
            case OfferDisplayLabelType.GOOD_PRICE:
                return (
                    <LocalizedStrict id="offer-tag-good-price">
                        <>Good price</>
                    </LocalizedStrict>
                )
            case OfferDisplayLabelType.GREAT_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-great-offer">
                        <>Great offer</>
                    </LocalizedStrict>
                )
            case OfferDisplayLabelType.BUY_NOW:
                return (
                    <LocalizedStrict id="offer-tag-buy-now">
                        <>Buy now</>
                    </LocalizedStrict>
                )
            case OfferDisplayLabelType.DISCOUNT:
                return (
                    <LocalizedStrict id="offer-tag-discount">
                        <>Discount</>
                    </LocalizedStrict>
                )
            case OfferDisplayLabelType.WEEK_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-week-offer">
                        <>Week's offer</>
                    </LocalizedStrict>
                )
            case OfferDisplayLabelType.DAY_OFFER:
                return (
                    <LocalizedStrict id="offer-tag-day-offer">
                        <>Today's offer</>
                    </LocalizedStrict>
                )
            default:
                return null
        }
    }

    const tagText = getTagText()

    if (!tagText) return null

    return (
        <Box className={classes.container}>
            <TagRounded>{tagText}</TagRounded>
        </Box>
    )
}
